import React from 'react';
import createIconComponent from '../utils/createIconComponent';
var IconBack = createIconComponent({
  iconData: {
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 40 40",
      "aria-hidden": "true",
      "focusable": "false",
      "fill": "currentColor",
      "width": "1em",
      "height": "1em"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10.7 17.3L27.5.5c.5-.5 1.4-.5 1.9 0l1.9 1.9c.5.5.5 1.4 0 1.9l-16 15.8L31.2 36c.5.5.5 1.4 0 1.9l-1.9 1.9c-.5.5-1.4.5-1.9 0L8.8 21c-.5-.5-.5-1.4 0-1.9l1.9-1.8z",
        "fillRule": "evenodd",
        "clipRule": "evenodd"
      }
    }]
  }
});
IconBack.displayName = 'IconBack';
export default IconBack;